var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumb-new"},[_c('Breadcrumb',[_c('label',{staticClass:"bread-head"},[_c('i',{staticClass:"iconfont icon-ico_site icon-address"}),_vm._v(" 您所在位置: ")]),_vm._l((_vm.routeArr),function(item,index){return [_c('BreadcrumbItem',{key:index},[_vm._v(" "+_vm._s(item.name)+" ")])]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }